import {Component, OnInit, ViewChild, Renderer} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {NgForm} from '@angular/forms';
import Swal from 'sweetalert2';
import {AccessControlService} from 'src/app/services/access-control.service';
import {AlertService} from '../../services/alert.service';
import {AuthService} from '../../services/auth.service';
// declare var $: any;
import {MatPaginator, MatTableDataSource, MatSort} from '@angular/material';
import {ToastrService} from 'ngx-toastr';
import {map} from 'rxjs/operators';


@Component({
  selector: 'app-section-listing',
  templateUrl: './section-listing.component.html',
  styleUrls: ['./section-listing.component.css']
})
export class SectionListingComponent implements OnInit {
  @ViewChild('addsectionForm') public addsectionForm: NgForm;
  model: any = {};
  moduleId: any;
  opt: any;
  buttonTitle: String = '';
  title: String = '';
  sectionModel: any = [];
  app_id: any;
  application: any = [];
  sectionList: any = [];
  application_name: any;
  displayedColumns: string[] = ['section_display_name', 'section_description', 'inherited_name', 'display_order', 'Actions'];
  isLoading: boolean;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  noData: any;
  dataSource: MatTableDataSource<any>;

  constructor(private authService: AuthService,
              private alertService: AlertService,
              private accesscontrolService: AccessControlService,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private renderer: Renderer, private toastrService: ToastrService) {
    this.moduleId = this.activatedRoute.snapshot.queryParamMap.get('id');
    // this.id = this.activatedRoute.snapshot.queryParamMap.get('id')
    this.opt = this.activatedRoute.snapshot.queryParamMap.get('opt');
    this.app_id = this.activatedRoute.snapshot.queryParamMap.get('app_id');
  }

  ngOnInit() {
    this.application_name = this.activatedRoute.snapshot.queryParams['appname'];
    this.getSectionByModulebyId();

  }

  getSectionByModulebyId() {
    this.isLoading = true;
    this.accesscontrolService.getSectionByModulebyId(this.moduleId, this.app_id).subscribe((res: any) => {
        this.model = res;
        this.sectionList = res['section'];
        this.dataSource = new MatTableDataSource<any>(res['section']);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.noData = this.dataSource.connect().pipe(map(data => data.length === 0));

        this.isLoading = false;
      }, error => {
        this.isLoading = false;
        console.log(error);
      },
      () => {
      });
  }

  verify(selected: any) {
    Swal({
      title: 'Are you sure you want to delete?',
      text: 'You won\'t be able to revert this!',
      type: 'warning',
      width: '30%',
      showCancelButton: true,
      confirmButtonColor: 'text-danger',
      cancelButtonColor: '#f8ac59',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.value) {

        this.removeSection(selected);
      }

    });
  }

  removeSection(selected_id: any) {
    for (var i = 0; i < this.model.section.length; i++) {
      if (selected_id == this.model.section[i]._id) {
        this.model.section.splice(i, 1);
      }
    }
    this.deleteSection();
  }

  deleteSection() {
    this.accesscontrolService.updatesystemModule(this.model, this.app_id).subscribe((res) => {
      this.toastrService.success('Section deleted successfully.');
      this.getSectionByModulebyId();
    }, error => {
      var errorMessage = error && error.error && error.error.message ? error.error.message : 'Sorry, Something went wrong!';
      this.toastrService.error(errorMessage);
    }, () => {
    });
  }

  back() {
    if (this.app_id) {
      this.router.navigate(['/edit-module-listing/' + this.app_id], {queryParamsHandling: 'preserve'});
    }
  }

  addsection() {
    this.router.navigate(['add-section'], {queryParams: {id: this.moduleId, app_id: this.app_id}, queryParamsHandling: 'merge'});
  }

  applyFilter(event: Event) {
    this.noData = this.dataSource.connect().pipe(map(data => data.length === 0));
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}

